import { useState } from 'react'
import { Trans, t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Stack, Switch, Typography, FormControlLabel, Alert } from '@mui/material'

import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import { useGetTimeTrackingConsentQuery, useUpdateTimeTrackingConsentMutation } from '@/core/api'

export function TimeTracking() {
  useLingui()

  const { data: consent, isLoading } = useGetTimeTrackingConsentQuery()
  const [updateConsent] = useUpdateTimeTrackingConsentMutation()
  const [confirmDisableOpen, setConfirmDisableOpen] = useState(false)

  const handleToggle = () => {
    if (consent?.enabled) {
      setConfirmDisableOpen(true)
    } else {
      updateConsent({ enabled: true })
    }
  }

  const handleConfirmDisable = () => {
    updateConsent({ enabled: false })
    setConfirmDisableOpen(false)
  }

  if (isLoading) return null

  return (
    <Stack spacing={2}>
      <Alert severity="info">
        <Trans>
          Time tracking allows you to record your working hours. Your sessions will be logged when you connect and disconnect. You can enable or disable this
          feature at any time.
        </Trans>
      </Alert>

      <FormControlLabel
        control={<Switch checked={consent?.enabled ?? false} onChange={handleToggle} />}
        label={
          <Typography variant="body1">
            <Trans>Enable time tracking</Trans>
          </Typography>
        }
      />

      {consent?.enabled && (
        <Typography variant="body2" color="text.secondary">
          <Trans>Your working sessions are being recorded. You can view your hours on the Time Tracking page.</Trans>
        </Typography>
      )}

      <ConfirmDialog
        open={confirmDisableOpen}
        title={t`Disable time tracking`}
        content={t`Your existing data will be kept, but no new sessions will be recorded.`}
        confirmText={t`Disable`}
        cancelText={t`Cancel`}
        onConfirm={handleConfirmDisable}
        onCancel={() => setConfirmDisableOpen(false)}
        confirmButtonProps={{ color: 'error' }}
      />
    </Stack>
  )
}
